<script>
import ThemeSwitcher from '../ThemeSwitcher';
import LanguageSwitcher from '../LanguageSwitcher.vue';
import feather from 'feather-icons';
import AppHeaderLinks from './AppHeaderLinks.vue';

export default {
  components: {
    ThemeSwitcher,
    LanguageSwitcher,
    AppHeaderLinks,
  },
  data() {
    return {
      isOpen: false,
      theme: '',
      modal: false,
      categories: [
        {
          id: 1,
          value: 'web',
          name: 'Web Application',
        },
        {
          id: 2,
          value: 'mobile',
          name: 'Mobile Application',
        },
        {
          id: 3,
          value: 'ui-ux',
          name: 'UI/UX Design',
        },
        {
          id: 4,
          value: 'writing',
          name: 'Journalist and Creative Writing',
        },
      ],
    };
  },

  created() {
    this.theme = localStorage.getItem('theme') || 'light';
  },
  mounted() {
    feather.replace();
    this.theme = localStorage.getItem('theme') || 'light';
  },
  updated() {
    feather.replace();
  },
  methods: {
    updateTheme(theme) {
      this.theme = theme;
    },
    showModal() {
      if (this.modal) {
        // Stop screen scrolling
        document
          .getElementsByTagName('html')[0]
          .classList.remove('overflow-y-hidden');
        this.modal = false;
      } else {
        document
          .getElementsByTagName('html')[0]
          .classList.add('overflow-y-hidden');
        this.modal = true;
      }
    },
  },
};
</script>

<template>
  <nav id="nav" class="sticky top-0 z-50 w-full bg-white/60 dark:bg-gray-900/40 shadow-sm">
    <!-- Header start -->
    <div class="z-10 max-w-screen-lg xl:max-w-screen-xl mx-auto block sm:flex sm:justify-between sm:items-center py-2 sm:py-4">
      <!-- Header menu links and small screen hamburger menu -->
      <div class="flex justify-between items-center px-4 sm:px-0">
        <!-- Header logos -->
        <div>
          <router-link to="/">
            <img v-if="theme === 'light'" src="@/assets/images/logo-dark.svg" class="w-36" alt="Dark Logo">
            <img v-else src="@/assets/images/logo-light.svg" class="w-36" alt="Light Logo">
          </router-link>
        </div>

        <!-- Theme switcher small screen -->
        <theme-switcher :theme="theme"
          class="block sm:hidden bg-ternary-light dark:bg-ternary-dark hover:bg-hover-light dark:hover:bg-hover-dark hover:shadow-sm px-2.5 py-2 rounded-lg"
          @themeChanged="updateTheme" />

        <!-- Small screen hamburger menu -->
        <div class="sm:hidden">
          <button type="button" class="focus:outline-none" aria-label="Hamburger Menu" @click="isOpen = !isOpen">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
              class="h-7 w-7 fill-current text-secondary-dark dark:text-ternary-light">
              <path v-if="isOpen" fill-rule="evenodd"
                d="M18.278 16.864a1 1 0 0 1-1.414 1.414l-4.829-4.828-4.828 4.828a1 1 0 0 1-1.414-1.414l4.828-4.829-4.828-4.828a1 1 0 0 1 1.414-1.414l4.829 4.828 4.828-4.828a1 1 0 1 1 1.414 1.414l-4.828 4.829 4.828 4.828z"
                clip-rule="evenodd" />
              <path v-if="!isOpen" fill-rule="evenodd"
                d="M4 5h16a1 1 0 0 1 0 2H4a1 1 0 1 1 0-2zm0 6h16a1 1 0 0 1 0 2H4a1 1 0 0 1 0-2zm0 6h16a1 1 0 0 1 0 2H4a1 1 0 0 1 0-2z" />
            </svg>
          </button>
        </div>
      </div>

      <!-- Header links -->
      <AppHeaderLinks :show-modal="showModal" :is-open="isOpen" />

      <!-- Header right section buttons -->
      <div class="hidden sm:flex justify-between items-center flex-col md:flex-row">

        <!-- Theme and Language Switcher -->
        <div class="flex items-center gap-3 ml-4">
          <!-- Theme switcher large screen -->
          <theme-switcher :theme="theme"
            class="bg-primary-light dark:bg-ternary-dark px-3 py-2 shadow-sm rounded-xl cursor-pointer"
            @themeChanged="updateTheme" />

          <!-- Language Switcher -->
          <LanguageSwitcher />
        </div>
      </div>
    </div>
  </nav>
</template>

<style scoped>
#nav a.router-link-exact-active {
  @apply text-indigo-700;
  @apply dark:text-indigo-400;
  @apply font-medium;
}
</style>
